module.exports = __webpack_public_path__ + "static/media/Unlined.34c97fd0.svg";